import React from 'react';
import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    TextField, Button, IconButton, Select, Box, MenuItem, InputLabel, FormControl, useTheme
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { tokens } from "../../../theme/theme";
import ClearIcon from '@mui/icons-material/Clear';

const NewProductGroupDialog = ({ open, onClose, onAdd, onClear, productGroup, handleInputChange }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const isAddDisabled = !productGroup.PGroupCode || !productGroup.PGroupDesc;

    return (
        <Dialog
            open={open}
            onClose={onClose}
            PaperProps={{
                style: {
                    position: 'absolute',
                    top: 0,
                    margin: '0px', // Adjust as needed
                },
            }}
        >
            <DialogTitle style={{ backgroundColor: theme.palette.background.default }}>
                New Product Group
            </DialogTitle>
            <DialogContent style={{ backgroundColor: theme.palette.background.default }}>
                <TextField
                    autoFocus
                    margin="dense"
                    name="PGroupCode"
                    size='small'
                    label="Product Group Code"
                    fullWidth
                    value={productGroup.PGroupCode}
                    onChange={handleInputChange}
                    required
                    error={!productGroup.PGroupCode}
                    helperText={!productGroup.PGroupCode && "Product Group Code is required"}
                />
                <TextField
                    margin="dense"
                    name="PGroupDesc"
                    size='small'
                    label="Group Description"
                    fullWidth
                    value={productGroup.PGroupDesc}
                    onChange={handleInputChange}
                    required
                    error={!productGroup.PGroupDesc}
                    helperText={!productGroup.PGroupDesc && "Group Description is required"}
                />
                <FormControl fullWidth margin="dense" size='small'>
                    <InputLabel>Status</InputLabel>
                    <Select
                        name="PGroupStatus"
                        value={productGroup.PGroupStatus}
                        onChange={handleInputChange}
                    >
                        {/* <MenuItem value=""><em>None</em></MenuItem> */}
                        <MenuItem value="A">Active</MenuItem>
                        <MenuItem value="IA">Inactive</MenuItem>
                    </Select>
                </FormControl>
            </DialogContent>
            <DialogActions style={{ backgroundColor: theme.palette.background.default }}>
               
                <Box justifyContent={'space-between'} >

                    <Button variant='contained' style={{ fontSize: '12px', marginRight: '8px', textTransform: 'none', backgroundColor: '#1769aa' }} onClick={onAdd}>
                        Save
                    </Button>

                    <Button
                        variant='contained' onClick={onClear}
                        style={{ marginRight: '10px', fontSize: '12px', backgroundColor: '#c5c7c6', color: 'black', textTransform: 'none', }} //borderRadius:'5px 5px 0px 5px'
                    >
                        Clear
                    </Button>

                </Box>
            </DialogActions>
        </Dialog>
    );
};

export default NewProductGroupDialog;
